import { useEffect, useState } from "react";

const STORAGE_KEY = "pt_cookie_consent";

export default function CookieConsent({ data }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const handle = (choice) => {
    localStorage.setItem(STORAGE_KEY, choice);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed bottom-4 left-4 right-4 md:right-auto md:left-4 md:bottom-4 md:max-w-md z-40 bg-onyx text-alabaster border border-gold/30 p-5 shadow-2xl"
    >
      <p className="text-sm leading-relaxed">{data.text}</p>
      {data.policyUrl && data.policyUrl !== "#" && (
        <a href={data.policyUrl} className="text-xs text-gold underline mt-1 inline-block">
          Saiba mais
        </a>
      )}
      <div className="mt-4 flex gap-2">
        <button
          data-testid="cookie-accept"
          onClick={() => handle("accepted")}
          className="flex-1 px-4 py-2 bg-gold text-onyx text-xs tracking-[0.2em] uppercase font-semibold hover:bg-alabaster transition-colors"
        >
          {data.acceptLabel || "Aceitar"}
        </button>
        <button
          data-testid="cookie-decline"
          onClick={() => handle("declined")}
          className="px-4 py-2 text-xs tracking-[0.2em] uppercase text-alabaster/60 hover:text-alabaster transition-colors border border-alabaster/20"
        >
          {data.declineLabel || "Recusar"}
        </button>
      </div>
    </div>
  );
}
